import React, { useState } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import Cta from '@components/Cta'
import './Ctas.module.scss'
import { supportsWebp } from '../../helpers/webp'
const renderCta = R.pipe(
  R.defaultTo([]),
  R.map((cta) => {
    const [format, setFormat] = useState('jpg')
    supportsWebp((isSupported) => {
      if (isSupported) {
        setFormat('webp')
      }
    })
    const data = R.or(R.prop('node', cta), cta)
    const id = R.prop('id', data)
    const title = R.prop('title', data)
    const slug = R.path(['page', 'slug'], data)
    var imageSrc = R.path(['image', 'resize', 'src'], data)
    if (!imageSrc.includes('progressive')) {
      imageSrc = imageSrc + `&fm=${format}`
    }
    const templateType = R.path(['page', 'template', 0, '__typename'], data)
    const category = R.path(['page', 'template', 0, 'category'], data)
    return (
      <Cta
        key={id}
        title={title}
        slug={slug}
        image={imageSrc}
        slugOptions={{type: templateType, category: category}}
      />
    )
  })
)

const Ctas = ({ data }) => {
  let ctaCount = false
  if (data && data.length === 5) {
    ctaCount = true
  }
  return (
    <div styleName={ctaCount ? `ctas ctas-5` : 'ctas'}>{renderCta(data)}</div>
  )
}

Ctas.propTypes = {
  data: PropTypes.array.isRequired
}

export default Ctas



// WEBPACK FOOTER //
// ./src/components/Ctas/Ctas.js